import React from 'react';
import { Trash2 } from 'lucide-react';
import { ABLE_COLORS } from '../../constants';

/**
 * ClearChatModal - Confirmation dialog for clearing chat history
 */
export default function ClearChatModal({ onConfirm, onCancel }) {
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1100
    }}>
      <div style={{
        background: 'white',
        borderRadius: '16px',
        padding: '24px',
        maxWidth: '320px',
        width: '90%',
        boxShadow: '0 10px 40px rgba(0,0,0,0.2)',
        textAlign: 'center'
      }}>
        <div style={{
          width: '48px',
          height: '48px',
          borderRadius: '50%',
          background: `${ABLE_COLORS.accent}15`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          margin: '0 auto 16px'
        }}>
          <Trash2 size={24} color={ABLE_COLORS.accent} />
        </div>
        <h3 style={{
          margin: '0 0 8px',
          fontSize: '18px',
          fontWeight: '600',
          color: '#333'
        }}>
          Clear chat history?
        </h3>
        <p style={{
          margin: '0 0 24px',
          fontSize: '14px',
          color: '#666',
          lineHeight: '1.5'
        }}>
          This will remove all messages. Your learned facts will be kept.
        </p>
        <div style={{ display: 'flex', gap: '12px', justifyContent: 'center' }}>
          <button
            onClick={onCancel}
            style={{
              padding: '10px 20px',
              border: `1px solid ${ABLE_COLORS.border}`,
              background: 'white',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '500',
              color: ABLE_COLORS.textSecondary,
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = ABLE_COLORS.bgSubtle;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = 'white';
            }}
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            style={{
              padding: '10px 20px',
              border: 'none',
              background: '#DC6B5A',
              borderRadius: '8px',
              fontSize: '14px',
              fontWeight: '500',
              color: 'white',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onMouseEnter={(e) => e.currentTarget.style.background = '#C55A4A'}
            onMouseLeave={(e) => e.currentTarget.style.background = '#DC6B5A'}
          >
            Clear
          </button>
        </div>
      </div>
    </div>
  );
}
